import { render, staticRenderFns } from "./Qrcode.vue?vue&type=template&id=9b20dac0&"
import script from "./Qrcode.vue?vue&type=script&lang=js&"
export * from "./Qrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports